import { render, staticRenderFns } from "./ManterAtasView.vue?vue&type=template&id=6d9e91cd"
import script from "./ManterAtasView.vue?vue&type=script&lang=js"
export * from "./ManterAtasView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports